export const SET_ALERTS = "EMERGENCY_SET_ALERTS";
export const SET_ALERTS_FULFILLED = "EMERGENCY_SET_ALERTS_FULFILLED";
export const REMOVE_ALERT = "EMERGENCY_REMOVE_ALERT";
export const REMOVE_ALERT_FULFILLED = "EMERGENCY_REMOVE_ALERT_FULFILLED"
